module.exports = __webpack_public_path__ + "static/img/UTM老师_Julie.d9cb273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTM/UTM老师_Julie.png
// module id = 501G
// module chunks = 0